import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import "./map-vender.scss";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { clientAdminFileUpload } from "@services/client-list.service";
import { toast } from "react-toastify";
import { updateTaskLicenseTask } from "@services/license.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import _ from "lodash";
import NoAccessPage from "@components/common/NoAccess";
import { convertDate, todayDate } from "@_common/date-helpers";
import CustomFileUpload from "@_common/custom-file-upload";
import PromptModal from "@prompt/modal";
import { useCallbackPrompt } from "@prompt/useCallbackPrompt";
import ShowCauseNoticeNavigation from "@components/Tasks/show-cause-notice";
import {
  createShowCauseNotice,
  getShowCauseNoticeDetails,
  getSpecificShowCauseNotice,
  updateShowCauseNotice,
} from "@services/causenotice.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  getChildEntityGroups,
  getEntityGroups,
  getEntityGroupsNew,
} from "@services/entity-mapping.service";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { adminGetUsers } from "@services/users.service";
import { removeNullOrUndefinedProperties } from "@_common/text-helpers";
import {
  adminGetCountriesListManagement,
  adminGetSCStatesListManagement,
} from "@services/list-management.service";
import { sanitizeInput } from "@_common/dompurify";

export default function ShowCauseNoticeEdit(props: any) {
  let params = useParams();
  let navigate = useNavigate();
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState({});
  const [request, setRequest] = useState<any>({
    country_id: 101,
    state_id: "",
    issuing_authority: "",
    notice_dated: "",
    received_on: "",
    notice_reply_deadline: "",
    remainder_required_on: "",
    show_cause_related_to: "",
    comments: "",
    action_taken: true,
    next_action_item: "",
    responsible_person: "",
    reporting_person: "",
    document_id: "",
    final_status: "",
  });
  const [dirtyFields, setDirtyFields] = useState<any>({
    country_id: 101,
    state_id: "",
    issuing_authority: "",
    notice_dated: "",
    received_on: "",
    notice_reply_deadline: "",
    remainder_required_on: "",
    show_cause_related_to: "",
    comments: "",
    action_taken: true,
    next_action_item: "",
    responsible_person: "",
    reporting_person: "",
    document_id: "",
    final_status: "",
  });
  const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
  const [daysList, setDaysList] = useState([]);
  const [reminder_date, setReminder_date] = useState<string | number | any>(
    "1",
  );

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getHeaderList(paramsObj, 0);
      getExecutorList("");
      getEvaluator("");

      if (getValue(params, `id`, "")) {
        getData();
      }
      getCountriesList();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [info, setInfo] = useState({});
  const getData = async () => {
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequests = QueryRequestHelper(payload);
    let entityResponse = await getEntityGroups(queryRequests);
    let entityHeaders = getValue(entityResponse, `data.entityGroups`, []);
    try {
      setLoading(true);
      let payload: any = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        search_text: params.search_text,
        show_cause_notice_id: params.id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSpecificShowCauseNotice(params.id);
      // let response = await getSpecificTaskLicense(params.id);

      if (resp) {
        //----------------- Params Obj Pending ----------------------//
        let paramObj: any = {};
        for (let i = 0; i < getValue(entityHeaders, `length`, 0); i++) {
          paramObj[
            `level${getValue(entityHeaders, `[${i}].group_level`, "")}`
          ] = `${getValue(resp, `data[level_${i + 1}].id`, "")}_${getValue(
            entityHeaders,
            `[${i}].id`,
            "",
          )}_${getValue(entityHeaders, `[${i}].group_level`, "")}`;
        }
        setParamsObj(paramObj);
        getPreFillHeaderList(paramObj);
        //-----------------------------------------------------------//

        setRequest({
          ...request,
          notice_dated: getValue(resp, `data.notice_dated`, "")
            ? new Date(getValue(resp, `data.notice_dated`, ""))
            : null,
          notice_reply_deadline: getValue(
            resp,
            `data.notice_reply_deadline`,
            "",
          )
            ? new Date(getValue(resp, `data.notice_reply_deadline`, ""))
            : null,
          received_on: getValue(resp, `data.received_on`, "")
            ? new Date(getValue(resp, `data.received_on`, ""))
            : null,
          remainder_required_on: getValue(
            resp,
            `data.remainder_required_on`,
            "",
          )
            ? new Date(getValue(resp, `data.remainder_required_on`, ""))
            : null,

          comments: getValue(resp, `data.comments`, ""),
          action_taken: getValue(resp, `data.action_taken`, false),
          next_action_item: getValue(resp, `data.next_action_item`, ""),
          show_cause_related_to: getValue(
            resp,
            `data.show_cause_related_to`,
            "",
          ),
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            "",
          ),
          document_id: getValue(resp, `document`, {}),
          final_status: getValue(resp, `data.final_status`, ""),
          issuing_authority: getValue(resp, `data.issuing_authority`, ""),
          country_id: getValue(resp, `data.country.id`, ""),
          state_id: getValue(resp, `data.state.id`, ""),
        });

        setDirtyFields({
          ...request,
          notice_dated: getValue(resp, `data.notice_dated`, "")
            ? new Date(getValue(resp, `data.notice_dated`, ""))
            : null,
          notice_reply_deadline: getValue(
            resp,
            `data.notice_reply_deadline`,
            "",
          )
            ? new Date(getValue(resp, `data.notice_reply_deadline`, ""))
            : null,
          received_on: getValue(resp, `data.received_on`, "")
            ? new Date(getValue(resp, `data.received_on`, ""))
            : null,
          remainder_required_on: getValue(
            resp,
            `data.remainder_required_on`,
            "",
          )
            ? new Date(getValue(resp, `data.remainder_required_on`, ""))
            : null,

          comments: getValue(resp, `data.comments`, ""),
          action_taken: getValue(resp, `data.action_taken`, false),
          next_action_item: getValue(resp, `data.next_action_item`, ""),
          show_cause_related_to: getValue(
            resp,
            `data.show_cause_related_to`,
            "",
          ),
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            "",
          ),
          document_id: getValue(resp, `document`, {}),
          final_status: getValue(resp, `data.final_status`, ""),
        });
        setUploadedDocuments(
          getValue(resp, `data.document`, null)
            ? [getValue(resp, `data.document`, {})]
            : [],
        );

        setTimeout(() => {
          setSelectedExecutor({
            ...getValue(resp, `data.responsible_person`, {}),
            label:
              getValue(resp, `data.responsible_person.first_name`, "") +
              " " +
              getValue(resp, `data.responsible_person.last_name`, ""),
            value:
              getValue(resp, `data.responsible_person.first_name`, "") +
              " " +
              getValue(resp, `data.responsible_person.last_name`, ""),
          });
          setSelectedEvaluator({
            ...getValue(resp, `data.reporting_person`, {}),
            label:
              getValue(resp, `data.reporting_person.first_name`, "") +
              " " +
              getValue(resp, `data.reporting_person.last_name`, ""),
            value:
              getValue(resp, `data.reporting_person.first_name`, "") +
              " " +
              getValue(resp, `data.reporting_person.last_name`, ""),
          });
        }, 500);

        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        let obj = JSON.parse(JSON.stringify(request));
        let document_ids = uploadedDocuments.map((item: object) => ({
          id: getValue(item, `id`, ""),
        }));
        let payload: any = {
          show_cause_related_to: getValue(obj, `show_cause_related_to`, ""),
          notice_dated: getValue(obj, `notice_dated`, "")
            ? todayDate(getValue(obj, `notice_dated`, ""))
            : null,
          received_on: getValue(obj, `received_on`, "")
            ? todayDate(getValue(obj, `received_on`, ""))
            : null,
          notice_reply_deadline: getValue(obj, `notice_reply_deadline`, "")
            ? todayDate(getValue(obj, `notice_reply_deadline`, ""))
            : null,
          remainder_required_on: getValue(obj, `remainder_required_on`, "")
            ? todayDate(getValue(obj, `remainder_required_on`, ""))
            : null,
          comments: getValue(obj, `comments`, ""),
          action_taken: getValue(obj, `action_taken`, false),
          next_action_item: getValue(obj, `next_action_item`, ""),
          reporting_person: getValue(selectedExecutor, `id`, ""),
          responsible_person: getValue(selectedEvaluator, `id`, ""),
          // document_ids: uploadedDocuments.map((item: object) => ({
          //   id: getValue(item, `id`, ""),
          // })),
          document_id: getValue(document_ids, `[${0}].id`, ""),
          country_id: getValue(obj, `country_id`, ""),
          state_id: getValue(obj, `state_id`, ""),
          issuing_authority: getValue(obj, `issuing_authority`, ""),
          final_status: getValue(obj, `final_status`, ""),
        };
        let payloadNew: any = {
          show_cause_related_to: getValue(obj, `show_cause_related_to`, ""),
          notice_dated: getValue(obj, `notice_dated`, "")
            ? todayDate(getValue(obj, `notice_dated`, ""))
            : null,
          received_on: getValue(obj, `received_on`, "")
            ? todayDate(getValue(obj, `received_on`, ""))
            : null,
          notice_reply_deadline: getValue(obj, `notice_reply_deadline`, "")
            ? todayDate(getValue(obj, `notice_reply_deadline`, ""))
            : null,
          remainder_required_on: getValue(obj, `remainder_required_on`, "")
            ? todayDate(getValue(obj, `remainder_required_on`, ""))
            : null,
          comments: getValue(obj, `comments`, ""),
          action_taken: getValue(obj, `action_taken`, false),
          next_action_item: getValue(obj, `next_action_item`, ""),
          reporting_person: getValue(selectedExecutor, `id`, ""),
          responsible_person: getValue(selectedEvaluator, `id`, ""),
          country_id: getValue(obj, `country_id`, ""),
          state_id: getValue(obj, `state_id`, ""),
          issuing_authority: getValue(obj, `issuing_authority`, ""),
          final_status: getValue(obj, `final_status`, ""),
        };
        let lengthOfLevels = Object.keys(paramsObj).length;
        let levelObj: any = {};
        for (let i = 0; i < lengthOfLevels; i++) {
          levelObj[`level_${i + 1}`] = paramsObj[`level${i + 1}`]
            ? parseInt(paramsObj[`level${i + 1}`].split("_")[0])
            : "";
        }
        setSubmitLoading(true);
        let resp;
        let obje = {
          ...payloadNew,
          ...levelObj,
        };
        let objec = {
          ...payload,
          ...levelObj,
        };
        if (getValue(params, `id`, "")) {
          resp = await updateShowCauseNotice(
            getValue(params, `id`, ""),
            uploadedDocuments.length > 0 ? objec : obje,
          );
        } else {
          resp = await createShowCauseNotice(
            removeNullOrUndefinedProperties({
              ...payload,
              ...levelObj,
            }),
          );
        }

        if (resp) {
          setSubmitLoading(false);
          confirmNavigation();
          toast.success("Updated successfully");
          navigate(`/report/show-cause-notice?${mainQueryRequest}`);
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  /* -----------------------------  Executor  ------------------------------ */

  const [executorList, setExecutorList] = useState([]);
  const [executorLoading, setExecutorLoading] = useState(false);
  const [selectedExecutor, setSelectedExecutor] = useState<any>("");
  const getExecutorList = async (search: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setExecutorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setExecutorLoading(false);
        setExecutorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          })),
        );
      } else {
        setExecutorLoading(false);
      }
    } catch (error) {
      setExecutorLoading(false);
    }
    if (!search) {
      setSelectedExecutor("");
    }
  };

  /* --------------------------------  Evaluator  ------------------------------ */
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
  const getEvaluator = async (search: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      setEvaluatorLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setEvaluatorLoading(false);
        setEvaluatorList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          })),
        );
      } else {
        setEvaluatorLoading(false);
      }
    } catch (error) {
      setEvaluatorLoading(false);
    }
    if (!search) {
      setSelectedEvaluator("");
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };
  const handleUploadDocumnets = async (e: any) => {
    Array.from(e.target.files).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
    });
  };

  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, "") !== id,
    );
    setUploadedDocuments(filtered);
  };
  /* -------------------------------------------------------------------------- */
  /*                                Prompt Section                              */
  /* -------------------------------------------------------------------------- */
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    setIsChanged(
      _.isEqualWith(request, dirtyFields, (a: any, b: any) => {
        // if both are null or equal to an empty string then they are equal
        if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
      }),
    );
  });
  const [showPrompt, confirmNavigation, cancelNavigation]: any =
    useCallbackPrompt(!isChanged);

  const [lifetime, setLifetime] = useState(false);

  // ----------------- Upload section ----------------- //
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    const files = Array.from(e.target.files);

    setUploadLoading(true);

    try {
      for (const item of files) {
        const formData = new FormData();
        formData.append("file", item as any);

        try {
          const resp = await clientAdminFileUpload(formData); // waits here

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
            setUploadedDocuments([...uploadedDocuments]);
          }
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    } finally {
      e.target.value = null;
      setUploadLoading(false);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  // ----------------- Entity Mapping Section ----------------- //

  // const [headerList, setHeaderList] = useState([]);
  // const [headerLoading, setHeaderLoading] = useState(true);
  // const [levelObj, setLevelObj] = useState<any>({});
  // const [paramsObj, setParamsObj] = useState<any>({});

  // const getPreFillHeaderList = async (paramsObj: any) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     status: params.status ? params.status : "",
  //     sort_by: params.sort_by,
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   try {
  //     let resp = await getEntityGroups(queryRequest);
  //     if (resp) {
  //       setHeaderList(getValue(resp, `data.entityGroups`, []));
  //       var result: any = {};
  //       for (
  //         let i = 0;
  //         i < getValue(resp, `data.entityGroups.length`, 0);
  //         i++
  //       ) {
  //         result[
  //           `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
  //         ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
  //       }
  //       if (Object.keys(levelObj).length === 0) {
  //         for (let x in result) {
  //           let keys = Object.keys(result[x])[0];
  //           levelObj[keys] = {};
  //         }
  //       }
  //       // delete params[`checkpoint_id[]`];
  //       let list =
  //         Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
  //       if (getValue(list, `length`, 0) > 0) {
  //         list.map((item: any, _index: number) => {
  //           let findNextLevelInfo = getValue(
  //             resp,
  //             `data.entityGroups`,
  //             []
  //           ).filter(
  //             (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
  //           );
  //           return getEntityList(
  //             getValue(findNextLevelInfo, `[${0}].id`, ""),
  //             item.split("_")[0],
  //             "",
  //             0
  //           );
  //         });
  //       } else {
  //         getEntityList(
  //           getValue(resp, `data.entityGroups[${0}].id`, ""),
  //           null,
  //           "",
  //           0
  //         );
  //       }
  //       setHeaderLoading(false);
  //     } else {
  //       setHeaderLoading(false);
  //     }
  //   } catch (error) {
  //     setHeaderLoading(false);
  //   }
  // };

  // const getHeaderList = async (paramsObj: any, index: number) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     status: params.status ? params.status : "",
  //     sort_by: params.sort_by,
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   try {
  //     let resp = await getEntityGroups(queryRequest);
  //     if (resp) {
  //       setHeaderList(getValue(resp, `data.entityGroups`, []));
  //       var result: any = {};
  //       for (
  //         let i = 0;
  //         i < getValue(resp, `data.entityGroups.length`, 0);
  //         i++
  //       ) {
  //         result[
  //           `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
  //         ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
  //       }
  //       if (Object.keys(levelObj).length === 0) {
  //         for (let x in result) {
  //           let keys = Object.keys(result[x])[0];
  //           levelObj[keys] = {};
  //         }
  //       }
  //       // delete params[`checkpoint_id[]`];
  //       let list =
  //         Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
  //       if (getValue(list, `length`, 0) > 0) {
  //         list.map((item: any, _index: number) => {
  //           let findNextLevelInfo = getValue(
  //             resp,
  //             `data.entityGroups`,
  //             []
  //           ).filter(
  //             (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
  //           );
  //           if (_index === index)
  //             return getEntityList(
  //               getValue(findNextLevelInfo, `[${0}].id`, ""),
  //               item.split("_")[0],
  //               "",
  //               index
  //             );
  //         });
  //       } else {
  //         getEntityList(
  //           getValue(resp, `data.entityGroups[${0}].id`, ""),
  //           null,
  //           "",
  //           index
  //         );
  //       }
  //       setHeaderLoading(false);
  //     } else {
  //       setHeaderLoading(false);
  //     }
  //   } catch (error) {
  //     setHeaderLoading(false);
  //   }
  // };

  // ----------------- Entity Mapping Section ----------------- //

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getPreFillHeaderList = async (paramsObj: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              [],
            ).filter(
              (ite: any) =>
                ite.group_level === parseInt(item.split("_")[2]) + 1,
            );
            return getEntityList(
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              "",
              0,
            );
          });
        } else {
          // Changed entity_parent from null to 1
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            1, // Initial entity_parent set to 1
            "",
            0,
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              [],
            ).filter(
              (ite: any) =>
                ite.group_level === parseInt(item.split("_")[2]) + 1,
            );
            if (_index === index)
              return getEntityList(
                getValue(findNextLevelInfo, `[${0}].id`, ""),
                item.split("_")[0],
                "",
                index,
              );
          });
        } else {
          // Changed entity_parent from null to 1
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            1, // Initial entity_parent set to 1
            "",
            index,
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number,
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1,
        );
        if (_index === index)
          return getEntityList(
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            item.split("_")[0],
            "",
            index,
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    index: number,
  ) => {
    if (id) {
      let payload = {
        entity_group: id,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setChildEntityLoading(true);
      try {
        // let resp = await getChildEntityGroups(queryRequest);
        let resp = await getEntityGroupsNew(id, entity_parent);
        if (resp) {
          levelObj[id] = getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          }));
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };
  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number,
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(obj, headerIndex);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  // const handleChange = (
  //   val: string,
  //   entity_group: string,
  //   parent_level: any,
  //   index: number
  // ) => {
  //   let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
  //     ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
  //         "_"
  //       )[0]
  //     : null;

  //   if (!val) {
  //     getEntityList(entity_group, entityID, "", index);
  //     let length = Object.keys(paramsObj).length;
  //     for (let i = parent_level; i <= length; i++) {
  //       let id =
  //         paramsObj[`level${i + 1}`] &&
  //         paramsObj[`level${i + 1}`].split("_")[1];
  //       if (id) {
  //         levelObj[id] = {};
  //       }
  //       delete paramsObj[`level${i}`];
  //     }
  //     let obj = {
  //       ...paramsObj,
  //     };
  //     setParamsObj(obj);
  //     getHeaderList(obj, index);
  //   } else {
  //     getEntityList(entity_group, entityID, val, index);
  //   }
  // };

  const handleChange = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number,
  ) => {
    // Set default entity_parent to 1 if no previous level exists
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_",
        )[0]
      : 1; // Default to 1 instead of null

    if (!val) {
      getEntityList(entity_group, entityID, "", index);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(entity_group, entityID, val, index);
    }
  };

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
      });
    }

    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          state_id: "",
        });
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
  };

  const [limit, setLimit] = useState(100);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      sort_by: params.sort_by,
      search_text: params.search_text,
      status: getValue(params, `status`, "")
        ? getValue(params, `status`, "")
        : "active",
    };
    return { ...payload };
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, ""),
    );

  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, ""),
    );

  /* ---------------------------  State List  ----------------------------- */
  const getStatesList = async (countryId: number) => {
    if (countryId) {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, country: countryId });
      try {
        // let resp = await adminGetStatesListManagement(countryId);
        let resp = await adminGetSCStatesListManagement(queryRequest);
        if (resp) {
          setStates(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `state_id`, ""),
              value: getValue(item, `state_name`, ""),
              label: getValue(item, `state_name`, ""),
            })),
          );
        } else {
        }
      } catch (error) {}
    } else {
      setRequest({ ...request });
    }
  };

  const [finalStatusList] = useState([
    { value: "OPEN", label: "Open" },
    // { value: "REPLY_SENT", label: "Reply Sent" },
    { value: "CLOSED", label: "Close" },
  ]);

  console.log(request, "===request===>");
  return (
    <>
      <Layout>
        {!loading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "report_show_cause_notice",
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <div className="show-cause-notice-main-wrap">
              <PromptModal
                showDialog={showPrompt}
                confirmNavigation={confirmNavigation}
                cancelNavigation={cancelNavigation}
              />
              <ShowCauseNoticeNavigation
                id={params.id}
                handleSubmit={handleSubmit}
                submitLoading={submitLoading}
                save={
                  getValue(props, `permissions`, []).includes("create")
                    ? true
                    : false
                }
                isChanged={isChanged}
                permissions={props.permissions}
              />

              <div className="map-vendor-wrapper w-100 pb-5">
                <div className="map-vendor__details d-flex align-items-flex-start m-0 show-cause-notice-card-main-wrap">
                  {/* Step 1 */}
                  <div className="map-vendor__check">
                    <div className="show-cause-notice-card-left">
                      <div className="map-vendor__checklist scn-card-left-body">
                        <div className="common-input-grid-item scn-card-field-wrap form-group">
                          <label className="checkpoint-active-details__label form-label">
                            Country *
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Country"
                              className="form-control w-100"
                              name="country_id"
                              id="country_id"
                              options={countryList}
                              value={country_ID}
                              onChange={(e: any) =>
                                handleChangeSelect(e, "country_id")
                              }
                              label="Country"
                              validator={simpleValidator}
                            />
                          </div>
                        </div>

                        <div className="scn-card-field-wrap form-group">
                          <label
                            htmlFor="state"
                            className="checkpoint-active-details__label form-label"
                          >
                            State *
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose State"
                              className="form-control w-100"
                              name="state_id"
                              id="state_id"
                              label="State"
                              options={states}
                              value={state_ID}
                              onChange={(e: any) =>
                                handleChangeSelect(e, "state_id")
                              }
                              isClear
                              validator={simpleValidator}
                            />
                          </div>
                        </div>

                        {headerLoading || !props.permissionAPITriggered ? (
                          <Loader />
                        ) : getValue(headerList, `length`, 0) > 0 ? (
                          headerList.map((searchObj, index) => {
                            let selectedLevel =
                              getValue(searchObj, `group_level`, 0) > 0
                                ? getValue(
                                    paramsObj,
                                    `level${parseInt(
                                      getValue(searchObj, `group_level`, ""),
                                    )}`,
                                    "",
                                  )
                                : "";
                            let currentSelectedItem =
                              selectedLevel.split("_")[0];
                            let selectedValue =
                              getValue(
                                levelObj,
                                `[${getValue(searchObj, `id`, "")}].length`,
                                [],
                              ) > 0 &&
                              getValue(
                                levelObj,
                                `[${getValue(searchObj, `id`, "")}]`,
                                [],
                              ).filter(
                                (item: any) =>
                                  item.id === parseInt(currentSelectedItem),
                              );
                            return (
                              <>
                                <div className={`scn-card-field-wrap`}>
                                  <div
                                    className="position-relative form-group  align-items-center cursor-pointer mb-0"
                                    key={`location-${index}`}
                                  >
                                    <div className="form-label">
                                      {getValue(searchObj, `group_name`, "")} *
                                    </div>
                                    <div className="form-group">
                                      <div className="filter-form-wrappper__location-input">
                                        <SearchableDropdownSelect
                                          placeholder={`Choose ${getValue(
                                            searchObj,
                                            `group_name`,
                                            "",
                                          )}`}
                                          options={getValue(
                                            levelObj,
                                            `[${getValue(
                                              searchObj,
                                              `id`,
                                              "",
                                            )}]`,
                                            [],
                                          )}
                                          searchLoading={false}
                                          handleChange={(val: any) =>
                                            handleChange(
                                              val,
                                              getValue(searchObj, `id`, ""),
                                              getValue(
                                                searchObj,
                                                `group_level`,
                                                "",
                                              ),
                                              index,
                                            )
                                          }
                                          handleClick={(e: any) =>
                                            handleClickEntity(
                                              getValue(e, `id`, ""),
                                              getValue(searchObj, `id`, ""),
                                              getValue(
                                                searchObj,
                                                `group_level`,
                                                "",
                                              ),
                                              index,
                                            )
                                          }
                                          value={
                                            getValue(
                                              selectedValue,
                                              `length`,
                                              0,
                                            ) > 0
                                              ? selectedValue[0]
                                              : ""
                                          }
                                          label="label"
                                          id="id"
                                          name={getValue(
                                            searchObj,
                                            `group_name`,
                                            "",
                                          )}
                                          // removeClose
                                          validator={simpleValidator}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <br /> */}
                              </>
                            );
                          })
                        ) : null}

                        <div className="common-input-grid-item scn-card-field-wrap">
                          <label className="checkpoint-active-details__label form-label">
                            Issuing Authority *
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="TEXT"
                              placeholder="Enter Issuing Authority"
                              className="form-control w-100"
                              name="issuing_authority"
                              id="issuing_authority"
                              value={getValue(request, `issuing_authority`, "")}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  issuing_authority: sanitizeInput(
                                    e.target.value,
                                  ),
                                })
                              }
                              label="Issuing Authority"
                              validator={simpleValidator}
                            />
                          </div>
                        </div>

                        <div className="common-input-grid-item scn-card-field-wrap">
                          <label className="checkpoint-active-details__label form-label">
                            Notice Related to
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="TEXT"
                              placeholder="Enter Cause Related to"
                              className="form-control w-100"
                              name="show_cause_related_to"
                              id="show_cause_related_to"
                              value={getValue(
                                request,
                                `show_cause_related_to`,
                                "",
                              )}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  show_cause_related_to: sanitizeInput(
                                    e.target.value,
                                  ),
                                })
                              }
                              label="Show Cause Related to"
                              // validator={simpleValidator}
                            />
                          </div>
                        </div>

                        <div className="common-input-grid-item scn-card-field-wrap">
                          <label className="checkpoint-active-details__label form-label">
                            Next Action Item *
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="TEXT"
                              placeholder="Enter Next Action Item"
                              className="form-control w-100"
                              name="next_action_item"
                              id="next_action_item"
                              value={getValue(request, `next_action_item`, "")}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  next_action_item: sanitizeInput(
                                    e.target.value,
                                  ),
                                })
                              }
                              label="Next Action Item"
                              validator={simpleValidator}
                            />
                          </div>
                        </div>

                        <div className="scn-card-field-wrap form-group">
                          <label
                            htmlFor="final_status"
                            className="checkpoint-active-details__label form-label"
                          >
                            Final Status *
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Enter Final Status"
                              className="form-control w-100"
                              name="final_status"
                              id="final_status"
                              value={finalStatusList.filter(
                                (item: object) =>
                                  getValue(item, `value`, "") ===
                                  getValue(request, `final_status`, ""),
                              )}
                              options={finalStatusList}
                              // onChange={(e: any) =>
                              //   setRequest({
                              //     ...request,
                              //     status: e.value,
                              //   })
                              // }
                              onChange={(e: any) => {
                                setRequest({
                                  ...request,
                                  final_status: e ? e.value : null,
                                });
                              }}
                              label="Final Status"
                              validator={simpleValidator}
                              isClear
                            />
                          </div>
                        </div>
                        <div className="common-input-grid-item scn-card-field-wrap w-100">
                          <label className="checkpoint-active-details__label form-label">
                            Comments
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <InputField
                              inputType="TEXTAREA_COMMON"
                              placeholder="Enter Comments"
                              className="form-control w-100"
                              name="comments"
                              id="comments"
                              value={getValue(request, `comments`, "")}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  comments: e.target.value,
                                })
                              }
                              label="Comments"
                              // validator={simpleValidator}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="common-grid scn-card-left-body"> */}

                      {/* </div> */}
                    </div>
                  </div>
                  {/* Step 2 */}
                  <div className="map-vendor__check show-cause-notice-card-right-wrap">
                    <div className="show-cause-notice-card-left">
                      <div className="form-group ">
                        <label className="form-label">Action Taken</label>
                        <div className="d-flex" style={{ height: `40px` }}>
                          <div className="d-flex align-items-center">
                            <input
                              type="radio"
                              className="new-radio cursor-pointer"
                              id={`location`}
                              checked={getValue(request, `action_taken`, "")}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  action_taken: !request.action_taken,
                                })
                              }
                            />
                            <label
                              style={{ marginRight: "10px", marginBottom: "0" }}
                            >
                              Yes
                            </label>
                          </div>
                          <div
                            className="d-flex align-items-center "
                            style={{ marginLeft: "20px" }}
                          >
                            <input
                              type="radio"
                              className="new-radio cursor-pointer"
                              id={`location`}
                              checked={!getValue(request, `action_taken`, "")}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  action_taken: !request.action_taken,
                                })
                              }
                            />
                            <label
                              style={{ marginRight: "10px", marginBottom: "0" }}
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          Responsible Person *
                        </label>
                        <SearchableDropdownSelect
                          placeholder={"Search Responsible Person"}
                          options={executorList}
                          searchLoading={executorLoading}
                          handleChange={(val: any) => getExecutorList(val)}
                          handleClick={(e: any) => setSelectedExecutor(e)}
                          value={selectedExecutor}
                          label="label"
                          id="id"
                          name="Responsible Person"
                          validator={simpleValidator}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Reporting Person *</label>
                        <SearchableDropdownSelect
                          placeholder={"Search Reporting Person"}
                          options={evaluatorList}
                          searchLoading={EvaluatorLoading}
                          handleChange={(val: any) => getEvaluator(val)}
                          handleClick={(e: any) => setSelectedEvaluator(e)}
                          value={selectedEvaluator}
                          label="label"
                          id="id"
                          name="Reporting Person"
                          validator={simpleValidator}
                        />
                      </div>
                      <div className=" d-flex">
                        <div className="position-relative form-group  align-items-center cursor-pointer mb-0">
                          <div className="common-grid">
                            <div className="common-input-grid-item">
                              <label className="checkpoint-active-details__label form-label">
                                Notice Date *
                              </label>
                              <div className="filter-form-wrappper__location-input">
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                                  value={
                                    getValue(request, `notice_dated`, "")
                                      ? new Date(
                                          getValue(request, `notice_dated`, ""),
                                        )
                                      : null
                                  }
                                  onChange={(event: any) =>
                                    setRequest({
                                      ...request,
                                      notice_dated: event,
                                      remainder_required_on: null,
                                    })
                                  }
                                  label={"Notice Date"}
                                  placeholderText="Enter Notice Date"
                                  validator={simpleValidator}
                                />
                              </div>
                            </div>
                            <div className="common-input-grid-item">
                              <label className="checkpoint-active-details__label">
                                Received On *
                              </label>
                              <div className="filter-form-wrappper__location-input">
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                                  value={
                                    getValue(request, `received_on`, "")
                                      ? new Date(
                                          getValue(request, `received_on`, ""),
                                        )
                                      : null
                                  }
                                  onChange={(event: any) =>
                                    getValue(request, `notice_dated`, null)
                                      ? setRequest({
                                          ...request,
                                          received_on: event,
                                          remainder_required_on: null,
                                        })
                                      : toast.error("Please Select Notice Date")
                                  }
                                  minDate={
                                    getValue(request, `notice_dated`, null)
                                      ? getValue(request, `notice_dated`, null)
                                      : new Date()
                                  }
                                  label={"Received on"}
                                  placeholderText="Enter Received on"
                                  validator={simpleValidator}
                                />
                              </div>
                            </div>
                            <div className="common-input-grid-item">
                              <label className="checkpoint-active-details__label">
                                Notice Reply Deadline *
                              </label>
                              <div className="filter-form-wrappper__location-input">
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                                  value={
                                    getValue(
                                      request,
                                      `notice_reply_deadline`,
                                      "",
                                    )
                                      ? new Date(
                                          getValue(
                                            request,
                                            `notice_reply_deadline`,
                                            "",
                                          ),
                                        )
                                      : null
                                  }
                                  label={"Notice Reply Deadline"}
                                  onChange={(event: any) =>
                                    getValue(request, `received_on`, null)
                                      ? setRequest({
                                          ...request,
                                          notice_reply_deadline: event,
                                          remainder_required_on: null,
                                        })
                                      : toast.error("Please Select Received On")
                                  }
                                  minDate={
                                    getValue(request, `received_on`, null)
                                      ? getValue(request, `received_on`, null)
                                      : new Date()
                                  }
                                  placeholderText="Notice Reply Deadline"
                                  validator={simpleValidator}
                                />
                              </div>
                            </div>
                            <div className="common-input-grid-item">
                              <label className="checkpoint-active-details__label">
                                Reminder Required on
                              </label>
                              <div className="filter-form-wrappper__location-input">
                                <InputField
                                  inputType="DATETYPE-DOB"
                                  className="release-date-wrapper__vendor-form-control form-control release-date-wrapper__vendor-form-control--calendar"
                                  value={
                                    getValue(
                                      request,
                                      `remainder_required_on`,
                                      "",
                                    )
                                      ? new Date(
                                          getValue(
                                            request,
                                            `remainder_required_on`,
                                            "",
                                          ),
                                        )
                                      : null
                                  }
                                  onChange={(event: any) =>
                                    setRequest({
                                      ...request,
                                      remainder_required_on: event,
                                    })
                                  }
                                  placeholderText="Enter Reminder Required on"
                                  maxDate={
                                    getValue(
                                      request,
                                      `notice_reply_deadline`,
                                      null,
                                    )
                                      ? getValue(
                                          request,
                                          `notice_reply_deadline`,
                                          null,
                                        )
                                      : null
                                  }
                                />
                              </div>
                            </div>

                            <div className="common-input-grid-item scn-custom-file-upload-wrapper">
                              <CustomFileUpload
                                handleDrop={handleDrop}
                                uploadLoading={uploadLoading}
                                disableUpload={disableUpload}
                                permissions={getValue(props, `permissions`, [])}
                                handleDragOver={handleDragOver}
                                handleUploadDocuments={handleUploadDocuments}
                              />
                              {getValue(uploadedDocuments, `length`, 0) > 0
                                ? uploadedDocuments.map(
                                    (item: object, key: number) => {
                                      return (
                                        <div
                                          key={key}
                                          className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                                        >
                                          <p
                                            className="cursor-pointer"
                                            onClick={() =>
                                              handleDownloadOnClick(
                                                getValue(item, `url`, ""),
                                                getValue(item, `name`, ""),
                                              )
                                            }
                                          >
                                            {getValue(item, `name.length`, "") >
                                            30
                                              ? getValue(item, `name`, "")
                                                  .substring(0, 30)
                                                  .concat("...")
                                              : getValue(item, `name`, "")}
                                          </p>
                                          {getValue(
                                            props,
                                            `permissions`,
                                            [],
                                          ).includes("update") && (
                                            <img
                                              src="/images/close-black.svg"
                                              className="img-fluid cursor-pointer"
                                              onClick={() =>
                                                handleRemoveUploadedFiles(
                                                  getValue(item, `id`, ""),
                                                )
                                              }
                                            />
                                          )}
                                        </div>
                                      );
                                    },
                                  )
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Layout>
    </>
  );
}
